<template>
  <transition enter-active-class="noop" leave-active-class="noop">
    <div v-show="show" class="box" :class="[`speed-${speed}`]">
      <transition
        :enter-active-class="enterActiveClass"
        :leave-active-class="leaveActiveClass"
      >
        <div
          class="dialog"
          :style="{ width }"
          v-show="show">
          <div v-if="!noHeader" class="modal-head">
            <slot name="header">{{title}}</slot>
            <span v-if="noOutClose && !noClose" class="close-icon" @click="close">
              <icon-close></icon-close>
            </span>
            <img
              v-if="!noOutClose"
              src="@/assets/images/icon_close.png"
              alt
              @click="close"
            >
          </div>
          <div class="content">
            <slot name="content"></slot>
          </div>
          <div v-if="!noFooter" class="footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </transition>
      <transition name="fade">
        <div v-if="!noMask" v-show="show" class="mask" @click="close('mask')"></div>
      </transition>
    </div>
  </transition>
</template>
<script>
import IconClose from '@/assets/svg/icon_close.svg'
export default {
  components: {
    IconClose
  },
  props: {
    width: {
      type: String,
      default: '400px'
    },
    show: {
      type: Boolean,
      required: true
    },
    bodyClass: {
      type: String,
      default: 'modal-open'
    },
    title: {
      type: String,
      default: ''
    },
    enterActiveClass: {
      type: String,
      default: 'bounceIn'
    },
    leaveActiveClass: {
      type: String,
      default: 'bounceOut'
    },
    speed: {
      type: String,
      default: 'normal'
    },
    noMask: {
      type: Boolean,
      default: false
    },
    noHeader: {
      type: Boolean,
      default: false
    },
    noFooter: {
      type: Boolean,
      default: false
    },
    noOutClose: {
      type: Boolean,
      default: false
    },
    noClose: {
      type: Boolean,
      default: false
    },
    maskNoClick: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    show(val) {
      const { bodyClass } = this
      if (val) {
        this.bodyAddClass(bodyClass)
      } else {
        this.bodyRemoveClass(bodyClass)
      }
    }
  },
  methods: {
    open() {
      this.$emit('update:show', true)
    },
    close(type) {
      if (type === 'mask' && this.maskNoClick) return false
      this.$emit('update:show', false)
    },
    bodyHasClass(className) {
      return document.body.classList.contains(className)
    },
    bodyAddClass(className) {
      if (!this.bodyHasClass(className) && !this.noMask) {
        document.body.classList.add(className)
      }
    },
    bodyRemoveClass(className) {
      if (this.bodyHasClass(className) && !this.noMask) {
        document.body.classList.remove(className)
      }
    }
  }
}
</script>

<style lang="scss">
  @import '~@/assets/styles/animation.scss';
</style>

<style lang="scss" scoped>
/* box */
.box {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 98;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all .2s ease-in-out;
  background-color: rgba(0, 0, 0, 0);
}
/* mask */
.mask {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  background-color: #000;
  opacity: 0.5;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity;
}
.fade-enter,
.fade-leave-to {
  opacity: 0 !important;
}

/* dialog */
.speed-normal {
  animation-duration: 0.65s;
  .dialog {
    animation-duration: 0.65s;
  }
  .mask {
    transition-duration: 0.35s;
  }
}
.speed-fast {
  animation-duration: 0.25s;
  .dialog {
    animation-duration: 0.25s;
  }
  .mask {
    transition-duration: 0.05s;
  }
}
.speed-slow {
  animation-duration: 1s;
  .dialog {
    animation-duration: 1s;
  }
  .mask {
    transition-duration: 0.5s;
  }
}
.dialog {
  animation-fill-mode: both;
  width: 920px;
  z-index: 2;
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  border-radius: 4px;
  outline: 0;
  box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);
  text-align: left;
}
.modal-head {
  font-size: 16px;
  color: $titleColor;
  font-weight: 500;
  position: relative;
  padding: 16px 20px;
  border-bottom: 1px solid #F1F1F1;
  img {
    position: absolute;
    top: -10px;
    right: -100px;
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
  .close-icon {
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 3;
    text-align: center;
    cursor: pointer;
    svg {
      width: 12px;
      height: 14px;
      fill: #CACACA;
      &:hover {
        fill: $themeColor;
      }
    }
  }
}
/* content */
.content {
  position: relative;
  padding: 20px;
  font-size: 14px;
  line-height: 28px;
  color: $titleColor;
}
.footer {
  text-align: right;
  margin: 8px 20px 20px 0;
}
.noop {
  animation-name: noop;
}
@keyframes noop {
  from,
  to {
  }
}

.bounceIn {
  animation-name: bounceIn;
}

@keyframes bounceIn {
  0%,
  20%,
  40%,
  60%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }
  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }
  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }
  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }
  to {
    opacity: 1;
    transform: scaleX(1);
  }
}

.bounceOut {
  animation-name: bounceOut;
}

@keyframes bounceOut {
  20% {
    transform: scale3d(0.9, 0.9, 0.9);
  }
  50%,
  55% {
    opacity: 1;
    transform: scale3d(1.1, 1.1, 1.1);
  }
  to {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
}
</style>
